import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {Component, OnInit} from '@angular/core';
import { MatChipInputEvent} from '@angular/material/chips';
import { ActivatedRoute, Router } from '@angular/router';
import { AJWebService } from 'src/services/ajWeb.service';


@Component({
  selector: 'app-user-access',
  templateUrl: './user-access.component.html',
  styleUrls: ['./user-access.component.css']
})
export class UserAccessComponent implements OnInit {
  public data:any=[]
  public SaasDetails:any=[];
  public clientName:string='';
  public projectName:string='';
  public market:string='';
  public marketUnit:string='';
  public clientGroup:string='';
  public masterUser:any='';
  public userlist:any=[];
  public userlisttoreqid:any=[];
  public user:any='';

  public E2E:string="";
  E2EExist: boolean=false;
  constructor(public ajWebService: AJWebService, private activatedRoute: ActivatedRoute, private route: Router) { }

  ngOnInit(): void {
    
    if(this.ajWebService.hometouseraccess == true){
      this.SaasDetails  = this.ajWebService.SaasDetails;
      this.clientName = this.SaasDetails[0].ClientName;
      this.projectName = this.SaasDetails[0].E2EName;
      this.market = this.SaasDetails[0].Market;
      this.marketUnit = this.SaasDetails[0].MarketUnit;
      this.clientGroup = this.SaasDetails[0].ClientGroup;
      this.masterUser = this.SaasDetails[0].RequestorID;
      this.E2E = this.SaasDetails[0].E2EUID;
      //this.data.push(this.masterUser);
      this.E2EExist=true;
      this.getUserList();
    }
    else{
      this.activatedRoute.queryParamMap.subscribe((params) => {
        const data = params as any;
        this.E2E = data.params.E2EUID;
        sessionStorage.setItem('E2E',this.E2E);
        //console.log(id);
        this.getSaaSDetails();
      });
    }
  }

  getUserList(){
    this.ajWebService.GetSaaSUsers(this.E2E).subscribe(userlist=>{
      this.userlist=userlist;
      this.userlisttoreqid = this.userlist.map(obj => obj.RequestorID);
      this.data = this.userlist.map(obj => obj.RequestorID);
      const found = this.data.find(element => element ==this.ajWebService.enterpriseId);
      if(this.ajWebService.enterpriseId!=found){
        this.route.navigateByUrl('/error');
      }
    })
  }
  getSaaSDetails(){
    this.ajWebService.GetSaasProvision(this.E2E).subscribe((data) => {
      this.ajWebService.SaasDetails = data;
      if (this.ajWebService.SaasDetails.length > 0) {
        this.SaasDetails  = this.ajWebService.SaasDetails;
        this.ajWebService.scope_title =
                this.SaasDetails[0].ClientName + ' | ' + this.SaasDetails[0].E2EName;
        this.clientName = this.SaasDetails[0].ClientName;
        this.projectName = this.SaasDetails[0].E2EName;
        this.market = this.SaasDetails[0].Market;
        this.marketUnit = this.SaasDetails[0].MarketUnit;
        this.clientGroup = this.SaasDetails[0].ClientGroup;
        this.masterUser = this.SaasDetails[0].RequestorID;
        this.data.push(this.masterUser);
        this.E2EExist=true;
        this.getUserList();
      } else {
        this.E2EExist =false;
        //this.route.navigateByUrl('/error');
      }
    });
  }
  keyPress(value){
    console.log(value);
    const found = this.data.find(element => element == value);
    if(found){
      this.ajWebService.showInfoMessage(`"${value}" already exists`)
    }
    else{
      value=value.split('@')[0];
      this.data.push(value);
    }
  }

  saveOneUser(){
    console.log(this.user);
    const found = this.data.find(element => element == this.user);
    if(found){
      this.ajWebService.showInfoMessage(`"${this.user}" already exists`)
    }
    else{
      this.user=this.user.split('@')[0];
      this.data.push(this.user);
    }
  }
  deleteTodo(item) {
    const found = this.userlisttoreqid.find(x=>x==item);
    if(item==found){
      this.ajWebService.showInfoMessage(`"${item}" cannot be removed`)
    }
    else{
      let index = this.data.indexOf(item);
      this.data.splice(index, 1);
    }
    // this.deletePopup.success(`Todo ${item.id} Deleted!`);
  }

  saveUserDetails(){

    const requestorIDs = this.data.map(user => ({ EnterpriseID: user }));
    const data = {
      E2EUID:  this.E2E,
      RequestorID: requestorIDs
    };
    this.ajWebService.CreateSaaSUser(data).subscribe(res=>{
      this.ajWebService.showSuccessMessage("Saved")
      this.getUserList();
      this.user='';
      //console.log(res)
    },err=>{
      this.ajWebService.showErrorMessage("Something went wrong!!")
    }
    )
  }

  cancel(){
    //this.ajWebService.Saas.emit(this.ajWebService.SelectedDC);
    this.route.navigateByUrl('/home/'+this.E2E);
  }
}
